import Cookies from 'js-cookie';
import { initObjectGallerySliders } from './gallery';

jQuery(function($) {
  const lang = (window.ajaxurl && window.ajaxurl.lang) || '';
  const baseCookie = 'wishlist_ids';
  const cookieName = lang ? `${baseCookie}_${lang}` : baseCookie;

  // one-time migration from old global cookie
  (function migrateLegacy() {
    const legacy = Cookies.get(baseCookie);
    const scoped = Cookies.get(cookieName);
    if (legacy && !scoped) {
      Cookies.set(cookieName, legacy, { expires: 30, path: '/' });
      Cookies.remove(baseCookie, { path: '/' });
    }
  })();

  function getWishlist() {
    const cookie = Cookies.get(cookieName);
    return cookie ? cookie.split(',').filter(Boolean) : [];
  }

  function saveWishlist(wishlist) {
    Cookies.set(cookieName, wishlist.join(','), { expires: 30, path: '/' });
  }

  function updateButtonState($btn, isSelected) {
    if (isSelected) $btn.removeClass('unselected').addClass('selected');
    else $btn.removeClass('selected').addClass('unselected');
  }

  function updateWishlistCount(count) {
    $('.wishlist-count').text(count);
  }

  window.refreshButtonStates = function() {
    const wishlist = getWishlist();
    $('.add-to-wishlist').each(function() {
      const id = String($(this).data('object-id'));
      updateButtonState($(this), wishlist.includes(id));
    });
  };

  function refreshWishlistContainer() {
    const wishlist = getWishlist();

    if ($('.wishlist-container').length) {
      if (wishlist.length === 0) {
        $('.wishlist-container').html('<p class="wishlist-empty text-center">' + (ajaxurl.empty || 'Your wishlist is empty.') + '</p>');
        return;
      }

      $('.wishlist-container').html('<p class="wishlist-loading text-center">' + (ajaxurl.loading || 'Loading...') + '</p>');

      $.ajax({
        url: ajaxurl.url,
        method: 'POST',
        data: {
          action: 'load_wishlist_items',
          object_ids: wishlist,
          lang, // optional: send lang if your handler needs it
        },
        success: function(response) {
          $('.wishlist-container').html(response);
          refreshButtonStates();
          initObjectGallerySliders();

          // Reinitialize lightbox for new content
          if (typeof lightbox !== 'undefined') {
            $('.wishlist-container .expand-gallery').off('click').on('click', function () {
              const galleryId = $(this).data('target');
              const gallery = document.querySelector(`a[data-lightbox="${galleryId}"]`);

              if (gallery) {
                const $gallery = $(gallery);
                lightbox.start($gallery);
              }
            });
          }
        },
        error: function() {
          $('.wishlist-container').html('<p class="wishlist-error text-center">' + ajaxurl.wishlist_error + '</p>');
        }
      });
    }
  }

  // init
  refreshButtonStates();
  updateWishlistCount(getWishlist().length);
  refreshWishlistContainer();

  // toggle
  $(document).on('click', '.add-to-wishlist', function() {
    const $btn = $(this);
    const objectId = String($btn.data('object-id'));
    let wishlist = getWishlist();
    const index = wishlist.indexOf(objectId);

    if (index > -1) {
      wishlist.splice(index, 1);
      updateButtonState($btn, false);
      $('.wishlist-container [data-object-id="' + objectId + '"]').remove();
      if (wishlist.length === 0) {
        $('.wishlist-container').html('<p class="wishlist-empty text-center">' + (ajaxurl.empty || 'Your wishlist is empty.') + '</p>');
      }
    } else {
      wishlist.push(objectId);
      updateButtonState($btn, true);
    }

    saveWishlist(wishlist);
    updateWishlistCount(wishlist.length);
  });
});
